<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        class="filter-item"
        v-model="listQuery.hotel_name"
        placeholder="酒店名称"
        style="width: 220px"
        clearable
      />
      <el-input
        class="filter-item"
        v-model="listQuery.order_no"
        placeholder="订单号"
        style="width: 220px"
        clearable
      />
      <el-input
        class="filter-item"
        v-model="listQuery.order_confirm_no"
        placeholder="供应商订单编号"
        style="width: 220px"
        clearable
      />
      <el-input
        class="filter-item"
        v-model="listQuery.pay_order_no"
        placeholder="支付流水号"
        style="width: 220px"
        clearable
      />
      <el-input
        class="filter-item"
        v-model="listQuery.system_order_no"
        placeholder="系统订单号"
        style="width: 220px"
        clearable
      />

      <el-select
        class="filter-item"
        v-model="listQuery.order_state"
        placeholder="供应商订单状态"
        style="width: 160px"
        clearable
      >
        <el-option label="预订成功" :value="1" />
        <el-option label="已取消" :value="2" />
        <el-option label="预订未到" :value="3" />
        <el-option label="已入住" :value="4" />
        <el-option label="已完成" :value="5" />
      </el-select>

      <el-select
        class="filter-item"
        v-model="listQuery.system_order_status"
        placeholder="系统订单状态"
        style="width: 160px"
        clearable
      >
        <el-option label="下单待处理" :value="100" />
        <el-option label="下单成功" :value="101" />
        <el-option label="下单失败" :value="102" />
        <el-option label="下单确认中" :value="103" />
        <el-option label="取消订单成功" :value="201" />
        <el-option label="取消订单失败" :value="202" />
        <el-option label="取消订单中" :value="203" />
      </el-select>

      <el-button class="filter-item" type="primary" @click="handleFilter"
        >搜索</el-button
      >
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
      :row-class-name="errorRow"
    >
      <el-table-column label="下单时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.order_date }}
        </template>
      </el-table-column>
      <el-table-column label="订单号" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.order_no }}
        </template>
      </el-table-column>
      <el-table-column label="支付流水号" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.pay_order_no }}
        </template>
      </el-table-column>
      <el-table-column label="跟代理商结算金额" min-width="140" align="center">
        <template slot-scope="scope">
          {{ scope.row.account_money }}
        </template>
      </el-table-column>

      <el-table-column label="渠道结算价" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.channel_money }}
        </template>
      </el-table-column>

      <el-table-column label="联系人姓名" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.link_man }}
        </template>
      </el-table-column>

      <el-table-column label="联系人手机" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.link_phone }}
        </template>
      </el-table-column>

      <el-table-column label="入住时间" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.travel_date }}
        </template>
      </el-table-column>

      <el-table-column label="离店时间" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.end_travel_date }}
        </template>
      </el-table-column>

      <el-table-column label="酒店名称" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.hotel ? scope.row.hotel.inn_name : '' }}
        </template>
      </el-table-column>

      <el-table-column label="房型名称" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.room_type ? scope.row.room_type.room_type_name : '' }}
        </template>
      </el-table-column>

      <el-table-column label="房间间数" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.room_num }}
        </template>
      </el-table-column>

      <el-table-column
        label="供应商订单编号(确认号)"
        min-width="110"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.order_confirm_no }}
        </template>
      </el-table-column>

      <!--      <el-table-column label="供应商订单支付总价" min-width="140" align="center">-->
      <!--        <template slot-scope="scope">-->
      <!--          {{ scope.row.total_rate }}-->
      <!--        </template>-->
      <!--      </el-table-column>-->

      <el-table-column label="供应商到店时间" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.last_arr_time }}
        </template>
      </el-table-column>

      <el-table-column label="供应商订单状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag type="primary" v-if="scope.row.order_state === 1"
            >预订成功</el-tag
          >
          <el-tag type="danger" v-else-if="scope.row.order_state === 2"
            >已取消</el-tag
          >
          <el-tag type="warning" v-else-if="scope.row.order_state === 3"
            >预订未到</el-tag
          >
          <el-tag type="warning" v-else-if="scope.row.order_state === 4"
            >已入住</el-tag
          >
          <el-tag type="success" v-else-if="scope.row.order_state === 5"
            >已完成</el-tag
          >
        </template>
      </el-table-column>

      <el-table-column label="供应商支付状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag type="info" v-if="scope.row.pay_state === 0">未付款</el-tag>
          <el-tag type="success" v-else-if="scope.row.pay_state === 1"
            >已付款</el-tag
          >
          <el-tag type="warning" v-else-if="scope.row.pay_state === 2"
            >退款处理中</el-tag
          >
          <el-tag type="danger" v-else-if="scope.row.pay_state === 3"
            >已退款</el-tag
          >
        </template>
      </el-table-column>

      <el-table-column label="系统订单号" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.system_order_no }}
        </template>
      </el-table-column>

      <el-table-column label="系统订单状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag type="info" v-if="scope.row.system_order_status === 100"
            >下单待处理</el-tag
          >
          <el-tag
            type="success"
            v-else-if="scope.row.system_order_status === 101"
            >下单成功</el-tag
          >
          <el-tag
            type="danger"
            v-else-if="scope.row.system_order_status === 102"
            >下单失败</el-tag
          >
          <el-tag
            type="warning"
            v-else-if="scope.row.system_order_status === 103"
            >下单确认中</el-tag
          >
          <el-tag
            type="success"
            v-else-if="scope.row.system_order_status === 201"
            >取消订单成功</el-tag
          >
          <el-tag
            type="danger"
            v-else-if="scope.row.system_order_status === 202"
            >取消订单失败</el-tag
          >
          <el-tag
            type="danger"
            v-else-if="scope.row.system_order_status === 203"
            >取消订单中</el-tag
          >
        </template>
      </el-table-column>

      <el-table-column label="操作处理失败信息" min-width="140" align="center">
        <template slot-scope="scope">
          {{ scope.row.handle_error_message }}
        </template>
      </el-table-column>

      <el-table-column label="创建时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at }}
        </template>
      </el-table-column>

      <el-table-column
        label="操作"
        width="250"
        align="center"
        fixed="right"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            type="warning"
            size="mini"
            @click="handleModifyLastArrTime(scope.row)"
            :disabled="scope.row.system_order_status !== 102"
            style="margin-top: 5px"
            >修改到店时间</el-button
          >

          <el-button
            type="warning"
            size="mini"
            @click="handleReOrder(scope.row)"
            :disabled="!(scope.row.system_order_status === 102)"
            style="margin-top: 5px"
            >重新下单</el-button
          >

          <el-button
            type="warning"
            size="mini"
            @click="handleCancelOrder(scope.row)"
            style="margin-top: 5px"
            :disabled="
              !(
                scope.row.order_state === 1 ||
                scope.row.system_order_status === 103
              )
            "
            >取消订单</el-button
          >

          <el-button
            type="warning"
            size="mini"
            @click="handleComplete(scope.row)"
            :disabled="handleCompleteStatus(scope.row)"
            style="margin-top: 5px"
            >处理完成</el-button
          >
          <el-button
            type="warning"
            size="mini"
            @click="syncOrder(scope.row)"
            style="margin-top: 5px"
            >同步订单</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[5, 10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!-- 修改到店时间 -->
    <el-dialog
      title="修改到店时间"
      :visible.sync="dialogVisibleModifyLastArrTime"
      width="60%"
      :close-on-click-modal="false"
    >
      <el-form
        ref="modifyLastArrTimeForm"
        :rules="modifyLastArrTimeRules"
        :model="modifyLastArrTimeForm"
        label-width="150px"
      >
        <el-form-item label="修改到店时间" prop="last_arr_time">
          <el-date-picker
            v-model="modifyLastArrTimeForm.last_arr_time"
            type="datetime"
            placeholder="选择日期时间"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleModifyLastArrTime = false"
          >取消</el-button
        >
        <el-button
          type="primary"
          @click="saveDataModifyLastArrTime"
          :loading="btnLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <!-- 修改到店时间 -->
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        hotel_name: '',
        order_id: '',
        state: '',
        order_code: '',
        order_state: '',
        system_order_no: '',
        system_order_status: '',
      },
      // 修改到店时间
      btnLoading: false,
      dialogVisibleModifyLastArrTime: false,
      modifyLastArrTimeForm: {
        order_id: '',
        last_arr_time: '',
      },
      modifyLastArrTimeRules: {
        last_arr_time: [
          { required: true, message: '到店时间不能为空', trigger: 'change' },
        ],
      },
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.listLoading = true
      request({
        url: '/api/backend/jinJiang/order/orderList',
        method: 'get',
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.items
        this.total = response.data.total
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    errorRow({ row }) {
      let errorStatus = [102, 202]
      if (
        errorStatus.includes(row.system_order_status) &&
        row.error_order_handle_status === 0
      ) {
        return 'error-row'
      }
      return ''
    },
    // 修改到店时间
    handleModifyLastArrTime(row) {
      this.modifyLastArrTimeForm = {
        order_id: row.order_id,
        last_arr_time: row.last_arr_time,
      }
      this.dialogVisibleModifyLastArrTime = true
      this.$nextTick(() => {
        this.$refs['modifyLastArrTimeForm'].clearValidate() //清除校验结果
      })
    },
    saveDataModifyLastArrTime() {
      this.$refs['modifyLastArrTimeForm'].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          request({
            url: '/api/backend/jinJiang/order/modifyLastArrTime',
            method: 'post',
            data: this.modifyLastArrTimeForm,
          })
            .then(() => {
              this.dialogVisibleModifyLastArrTime = false
              this.$message({
                type: 'success',
                message: '操作成功',
              })
              this.getList()
            })
            .finally(() => {
              this.btnLoading = false
            })
        }
      })
    },
    // 重新下单
    handleReOrder(row) {
      this.$confirm('确认继续该操作', '提示', {
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/jinJiang/order/reOrder',
            method: 'post',
            data: {
              order_id: row.order_id,
            },
          }).then(() => {
            this.getList()
            this.$message({
              type: 'success',
              message: '操作成功',
            })
          })
        })
        .catch(() => {})
    },
    // 取消订单
    handleCancelOrder(row) {
      this.$confirm('确认继续该操作', '提示', {
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/jinJiang/order/cancelOrder',
            method: 'post',
            data: {
              order_id: row.order_id,
            },
          }).then(() => {
            this.getList()
            this.$message({
              type: 'success',
              message: '操作成功',
            })
          })
        })
        .catch(() => {})
    },
    // 处理完成
    handleComplete(row) {
      this.$confirm('确认继续该操作', '提示', {
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/jinJiang/order/handleComplete',
            method: 'post',
            data: {
              order_id: row.order_id,
            },
          }).then(() => {
            this.getList()
            this.$message({
              type: 'success',
              message: '操作成功',
            })
          })
        })
        .catch(() => {})
    },
    // 同步订单
    syncOrder(row) {
      this.$confirm('确认继续该操作', '提示', {
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/jinJiang/order/syncOrder',
            method: 'post',
            data: {
              order_id: row.order_id,
            },
          }).then(() => {
            this.getList()
            this.$message({
              type: 'success',
              message: '操作成功',
            })
          })
        })
        .catch(() => {})
    },
    handleCompleteStatus(row) {
      let errorStatus = [102, 202]
      return !(
        errorStatus.includes(row.system_order_status) &&
        row.error_order_handle_status === 0
      )
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
::v-deep .el-table .error-row {
  background-color: rgba(255, 0, 0, 0.2);
}
</style>
